import { Globe2, Plus } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { EmptyState } from "@/components/ui/empty-state"

type SegmentAnalysisEmptyDetailProps = {
  canCreate?: boolean
  onCreate?: () => void
}

export function SegmentAnalysisEmptyDetail({
  canCreate = false,
  onCreate,
}: SegmentAnalysisEmptyDetailProps) {
  return (
    <section className="border-border bg-card rounded-lg border border-dashed px-6 shadow-sm sm:px-12">
      <EmptyState
        className="mx-auto max-w-lg"
        description="Pick any segment card or bubble above to open its segment plan here — market size, customers and competitors, kept current by the AI agents."
        icon={Globe2}
        title="No segment selected"
        primaryAction={
          canCreate && onCreate ? (
            <Button onClick={onCreate}>
              <Plus className="size-4" />
              New segment
            </Button>
          ) : undefined
        }
      />
    </section>
  )
}
